export type GovernorProductionActionContract = {
  rootCause: string;
  owningFiles: string[];
  evidence: string[];
  safePatchPlan: string[];
  rollbackPlan: string[];
  verificationCommands: string[];
};

export function validateGovernorProductionActionContract(
  contract: GovernorProductionActionContract,
): { status: 'PASS' | 'FAIL'; missing: string[] } {
  const missing: string[] = [];

  if (!contract.rootCause.trim()) missing.push('rootCause');
  if (!contract.owningFiles.length) missing.push('owningFiles');
  if (!contract.evidence.length) missing.push('evidence');
  if (!contract.safePatchPlan.length) missing.push('safePatchPlan');
  if (!contract.rollbackPlan.length) missing.push('rollbackPlan');
  if (!contract.verificationCommands.length) missing.push('verificationCommands');

  return { status: missing.length ? 'FAIL' : 'PASS', missing };
}
